import mitt from 'mitt'

type Events = {
  'add-drop-charge': void
  'xero-service-type-change': void
}
const emitter = mitt<Events>()

export default emitter
